import { render, staticRenderFns } from "./OrderDetailsCustomerPanel.vue?vue&type=template&id=d9bf1054"
import script from "./OrderDetailsCustomerPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetailsCustomerPanel.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports